import { render, staticRenderFns } from "./TicketStatsModal.vue?vue&type=template&id=4ec96b9e&scoped=true&"
import script from "./TicketStatsModal.vue?vue&type=script&lang=js&"
export * from "./TicketStatsModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatsModal.vue?vue&type=style&index=0&id=4ec96b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec96b9e",
  null
  
)

export default component.exports